import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=50297576"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50297576')) {
      api.createRecord('50297576', component.options)
    } else {
      api.reload('50297576', component.options)
    }
    module.hot.accept("./CustomerList.vue?vue&type=template&id=50297576", function () {
      api.rerender('50297576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/customer/components/CustomerList.vue"
export default component.exports